import { Link } from "react-router-dom";
import Seo from "@/components/common/Seo";

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-50 px-4 text-center">
      <Seo title="页面不存在 - 韩漫大全" description="抱歉，你要访问的页面不存在，返回韩漫大全首页继续浏览好看韩漫吧。" />
      <span className="flex h-16 w-16 items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
        <i className="ri-ghost-smile-fill text-3xl" />
      </span>
      <h1 className="heading-font mt-6 text-4xl font-bold text-foreground-950">404</h1>
      <p className="mt-3 text-base text-foreground-600">抱歉，你要找的页面走丢了，换一页继续看好看的韩漫吧。</p>
      <div className="mt-8 flex flex-col gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line" /> 返回首页
        </Link>
        <Link
          to="/list"
          className="inline-flex items-center justify-center gap-2 rounded-full bg-background-100 px-6 py-3 text-sm font-bold text-foreground-800 whitespace-nowrap transition-colors hover:bg-background-200"
        >
          <i className="ri-book-open-line" /> 浏览全部韩漫
        </Link>
      </div>
    </div>
  );
}